import { TecLoader } from "./TechLoader";
import { TecItemCreate } from "./TecItemCreate";

/**
 * [執筆者ページ処理] jsonから該当執筆者の記事一覧を生成
 * @export
 * @class TechWriter
 */
export class TechWriter {
  private id:any = String($('article').attr('data-writer')).split(',');

  constructor() {
    new TecLoader( (data)=> { this.onData(data) } );
  }

  public onData(e):void {
    var result_str:any;
    var entry = e.entry;
    var data:any;
    var src:any = {
      category: e.category,
      writers: e.writers,
      entry: []
    };

    // 該当執筆者記事を抽出
    for( var i = 0; i < entry.length; i++ ) {
      data = entry[i];
      if (this.isInArray(this.id, data.writersid)) {
        src.entry.push( data )
      }
    }

    // 表示用ソース生成
    var item:TecItemCreate = new TecItemCreate();
    result_str = item.createItem(src);
    if (result_str.src_string !== '') {
    //   $('#contents--list').find('.section__inner').append('<div class="section__inner--block"><div class="technology__indexlist"><ul class="clearfix">' + result_str.src_string + '</ul></div></div>');
    $('.m_photoBox').append(result_str.src_string);
    }
  }


  /**
	 * util - 配列比較 配列内に共通の値があるか
	 * @param {*} arr1
	 * @param {*} arr2
	 * @returns
	 * @memberof News
	 */
	private isInArray(arr1, arr2) {
		var res = false;
		for (var i = 0; i < arr1.length; i++) {
			for (var j = 0; j < arr2.length; j++) {
				if (arr1[i] === arr2[j]) {
					res = true;
				}
			}
		}
		return res;
	}
}